import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquareIcon, MessageSquareIcon, UsersIcon, CalendarIcon, FileTextIcon, BarChartIcon } from 'lucide-react';
const features = [{
  icon: <CheckSquareIcon className="h-12 w-12 text-brand-teal" data-id="element-386" />,
  title: 'Task Management',
  description: 'Create, assign, and track tasks with customisable boards and lists. Set due dates, priorities, and dependencies to keep projects on track.'
}, {
  icon: <MessageSquareIcon className="h-12 w-12 text-brand-teal" data-id="element-387" />,
  title: 'Team Communication',
  description: 'Built-in messaging and comments keep conversations contextual. Mention team members and clients to keep everyone in the loop.'
}, {
  icon: <UsersIcon className="h-12 w-12 text-brand-teal" data-id="element-388" />,
  title: 'Client Portal',
  description: 'Give clients secure access to their projects. Share updates, files, and timelines without endless email threads.'
}, {
  icon: <CalendarIcon className="h-12 w-12 text-brand-teal" data-id="element-389" />,
  title: 'Calendar Integration',
  description: 'Sync deadlines and milestones with your calendar. Get reminders and never miss an important date.'
}, {
  icon: <FileTextIcon className="h-12 w-12 text-brand-teal" data-id="element-390" />,
  title: 'File Sharing',
  description: 'Store and share files securely. Version control ensures everyone works with the latest documents.'
}, {
  icon: <BarChartIcon className="h-12 w-12 text-brand-teal" data-id="element-391" />,
  title: 'Reporting & Analytics',
  description: 'Track team performance, project progress, and client satisfaction with comprehensive dashboards.'
}];
export const Platform = () => {
  return <div className="bg-white" data-id="element-392">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-393">
        <div className="container-custom" data-id="element-394">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-395">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-396">
              A complete platform for modern teams
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-397">
              Everything you need to manage projects, communicate with clients,
              and collaborate with your team—all in one place.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-398">
        <div className="container-custom" data-id="element-399">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-400">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-light rounded-lg p-8" data-id="element-401">
                <div className="mb-6" data-id="element-402">{feature.icon}</div>
                <h3 className="text-xl font-bold text-brand-blue mb-3" data-id="element-403">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-404">{feature.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
};